/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { renderToStaticMarkup } from 'react-dom/server';

// util fn to render component and return html string.
export function renderComponentToString(component: JSX.Element): string {
  return renderToStaticMarkup(component);
}

export function calculateAge(birthdate: string): number | undefined {
  try {
    const birthDateObj = new Date(birthdate);

    if (isNaN(birthDateObj.getTime())) {
      throw new Error('Invalid birthdate format');
    }

    const today = new Date();
    const birthYear = birthDateObj.getFullYear();
    const birthMonth = birthDateObj.getMonth();
    const birthDay = birthDateObj.getDate();

    let age = today.getFullYear() - birthYear;
    if (today.getMonth() < birthMonth || (today.getMonth() === birthMonth && today.getDate() < birthDay)) {
      age--;
    }

    return age;
  } catch (err) {
    console.error(`Error converting date string:${birthdate},message:${(err as Error).message}`);
  }
}

/*
export const excludedList = [
  'his',
  'himself',
  'hers',
  'herself',
  'their',
  'theirs',
  'themselves',
  'zirs',
  'zirself',
  'hirs',
  'hirself',
  'coself',
  'enself',
  'eir',
  'eirs',
  'emself',
  'yoself',
  'ver',
  'verself',
];
export function getPreferredPronoun(extension?: IExtension[]) {
  const pronouns = extension?.find(
    (ext) =>
      ext.url === 'http://hl7.org/fhir/StructureDefinition/individual-pronouns' ||
      'http://open.epic.com/FHIR/StructureDefinition/extension/calculated-pronouns-to-use-for-text'
  )?.valueCodeableConcept?.coding?.[0]?.display;

  if (!pronouns) return '- -';
  if (pronouns) {
    const pronounList = pronouns.split('/');
    const resultList: string[] = [];

    pronounList.forEach((item) => {
      if (!excludedList.includes(item) && !resultList.includes(item) && resultList.length < 2) {
        const capitalizedItem = item.charAt(0).toUpperCase() + item.slice(1).toLowerCase();
        resultList.push(capitalizedItem);
      }
    });
    return resultList.join('/');
  }
}
*/
